import React, {useEffect, useState} from 'react';
import {useAppBridge} from '@shopify/app-bridge-react';

// types
import {Intent, PlainObject} from '~/types/shopify.types';
import ProfessionalLetterPlain from '~/pages/plain/ProfessionalLetter';

const ProfessionalLetter: React.FC<React.PropsWithoutRef<any>> = () => {
  const shopify = useAppBridge();
  const [intent, setIntent] = useState<Intent | PlainObject>({});

  useEffect(() => {
    const cleanup = shopify.intents.register(setIntent);

    return () => cleanup();
  }, [shopify.intents]);

  return (
    <ProfessionalLetterPlain
      intent={(intent as Intent)}
      onComplete={fields => intent.finish(fields)}/>
  );
};

export default ProfessionalLetter;
